import { Injectable } from '@angular/core';
import { EMPTY, of } from 'rxjs'

import { BusinessInformation, BusinessInformationAdapter, Deal, DealAdapter, ContactDetail, ContactDetailAdapter, BusinessViewRows, ViewParametersAdapter, ViewParameters, IndustryDetail, IndustryDetailAdapter } from 'app/shared/models/evilo-models';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, delay } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BusinessService {

  saveBusinessServiceURL = environment.saveBusinessServiceURL;
  getBusinessServiceURL = environment.getBusinessServiceURL;
  searchBusinessServiceURL = environment.searchBusinessServiceURL;
  getAllBusinessServiceURL = environment.getAllBusinessServiceURL;
  getBusinessViewServiceURL = environment.getBusinessViewServiceURL;

  // associatedBusinessesServiceURL = environment.associatedBusinessesServiceURL;

  constructor(private http: HttpClient,
    private businessAdapter: BusinessInformationAdapter,
    private dealAdapter: DealAdapter,
    private industryDetailAdapter: IndustryDetailAdapter,
    private contactDetailAdapter: ContactDetailAdapter,
    private viewParametersAdapter: ViewParametersAdapter) { }

  saveBusinesses(businessInformation: BusinessInformation[]): Observable<any> {
    console.log('inside service call' + JSON.stringify(businessInformation));
    const s = { businessInformations: businessInformation };
    return this.http.post(this.saveBusinessServiceURL, s, { responseType: 'json' }).pipe(
      catchError(this.handleError));
  }

  getBusinesses(id: string[]): Observable<BusinessInformation[]> {
    const s = { companyIDs: id };
    return this.http.post(this.getBusinessServiceURL, s).pipe(
      map((data: any[]) => data.map(item => this.businessAdapter.adapt(item))),
      catchError(this.handleError));
  }

  getAllBusinesses(): Observable<BusinessInformation[]> {
    return this.http.get(this.getAllBusinessServiceURL).pipe(
      map((data: any[]) => data.map(item => this.businessAdapter.adapt(item))),
      catchError(this.handleError));
  }

  getBusinessView(param: any): Observable<BusinessViewRows> {
    const viewParams: ViewParameters = this.viewParametersAdapter.adapt(param)
    const requestJson = { viewParameters: viewParams }
    console.info("Called post api with request: ", requestJson)
    return this.http.post(this.getBusinessViewServiceURL, requestJson).pipe(
      map((data: any) => {
        var val: BusinessViewRows = data
        return val;
      }),
      catchError(this.handleError));
  }

  searchBusiness(param: string): Observable<BusinessInformation[]> {
    if (param) {
      return this.http.get(this.searchBusinessServiceURL + '?pattern=' + param).pipe(
        map((data: any[]) => data.map(item => this.businessAdapter.adapt(item))),
        catchError(this.handleError));
    }
    else
      return EMPTY;
  }

  searchIndustry(param: string): Observable<any[]> {
    let items = this.getMockIndustries();
    if (param) {
        items = items.filter(x => x.industryName.toLocaleLowerCase().indexOf(param.toLocaleLowerCase()) > -1);
    }
    return of(items).pipe(delay(500));
}

searchProductService(param: string): Observable<any[]> {
  let items = this.getMockProducts();
  if (param) {
      items = items.filter(x => x.productName.toLocaleLowerCase().indexOf(param.toLocaleLowerCase()) > -1);
  }
  return of(items).pipe(delay(500));
}

getMockProducts(){
  return [
    {productID : 1, productName : 'IT-Software', classification : 'NIC-2008', description : 'Software Industry', tags : ['IT', 'software', 'service'], version : 1},
  ]
}
  

  getMockIndustries(){
    return [
      {industryID : 1, industryName : 'IT-Software', classification : 'NIC-2008', description : 'Software Industry', tags : ['IT', 'software', 'service'], version : 1},
      {industryID : 2, industryName : 'Electronics', classification : 'NIC-2008', description : 'Electronics Industry', tags : ['IT', 'software', 'service'], version : 1},
      {industryID : 3, industryName : 'Education', classification : 'NIC-2008', description : 'Schools & Colleges', tags : ['IT', 'software', 'service'], version : 1},
      {industryID : 4, industryName : 'Mining', classification : 'NIC-2008', description : 'Mining Industry', tags : ['IT', 'software', 'service'], version : 1},
      {industryID : 5, industryName : 'Machine Manufacturing', classification : 'NIC-2008', description : 'Machines Manufacturing Industry', tags : ['IT', 'software', 'service'], version : 1},
      {industryID : 6, industryName : 'Construction', classification : 'NIC-2008', description : 'Construction Industry', tags : ['IT', 'software', 'service'], version : 1},
      {industryID : 7, industryName : 'Real Estate', classification : 'NIC-2008', description : 'Rela Estate Industry', tags : ['IT', 'software', 'service'], version : 1}
    ]

  }

  // getAssociatedBusinesses(params): Observable<BusinessInformation[]> {
  //   console.log('getAssociatedBusinesses: ', params);
  //   return this.http.post(this.associatedBusinessesServiceURL, params).pipe(
  //     map((data: any[]) => data.map(item => this.businessAdapter.adapt(item))),
  //     catchError(this.handleError));
  // }

  private handleError(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('Client Side Error :', errorResponse.error.message);
    } else {
      console.error('Server Side Error :', errorResponse);
    }
    return throwError('There is a problem with the service. We are notified & working on it. Please try again later.');
  }
}
